@import 

<template>
  <div class="pure-g">
    <div class="pure-u-1-5"></div>
    <div class="pure-u-3-5">
      <br />
      <img class="album_art" :src=album.coverSrc />
      <h3>{{album.title}}</h3>
      <div>
        <span v-html="album.description"></span>
      </div>
      <br />
      <br />
      <div style="text-align: left">
      <aplayer :music="list[0]" :list="list" :repeat="'list'" />
      </div>
      <br /><br />
    </div>
    <div class="pure-u-1-5"></div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex";
import Aplayer from "vue-aplayer";
export default {
  name: "AlbumDetail",
  data() {
    return {
      msg: "Three Brothers Music"
    };
  },
  methods: {
    ...mapActions(["getSelectedAlbum", "changeSelectedAlbum"]),
    changeSelectedAndRoute(id) {
      this.changeSelectedAlbum(id);
      this.$router.push("album");
    }
  },
  computed: mapState({
    // arrow functions can make the code very succinct!
    list(state) {
      let album = state.albums.album_array[state.albums.selectedAlbum];
      let list = [];
      for (var a = 0; a < album.tracks.length; a++) {
        list.push({
          src:
            "static/tracks/" +
            album.track_root +
            "/" +
            album.tracks[a].file_name,
          title: album.tracks[a].name,
          artist: album.tracks[a].artist,
          pic: album.coverSrc
        });
      }
      console.log("list", list);
      return list;
    },
    album(state) {
      return state.albums.album_array[state.albums.selectedAlbum];
    }
  }),
  components: {
    Aplayer
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.album_art {
  width: 128px;
  height: 128px;
}
</style>



// WEBPACK FOOTER //
// src/components/AlbumDetail.vue